import React, { useEffect, useState } from 'react';
import api from '../api';

const CURRENT_YEAR = new Date().getFullYear();
const ROW_LABELS = ['일자', '출석', '결원', '누적시수'];

const CLASSTYPE_LABELS = { '': '전체', R: '정규반', M: '면장반' };

export default function ClassStatus() {
  const [year, setYear] = useState(CURRENT_YEAR);
  const [grade, setGrade] = useState(1);
  const [classtype, setClasstype] = useState('M');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    api
      .get('/class-status', { params: { year, grade, classtype: classtype || undefined } })
      .then((res) => setRows(res.data))
      .finally(() => setLoading(false));
  }, [year, grade, classtype]);

  const classCount = rows[0]?.columns.length ?? 9;

  const cellValue = (row, classIndex, rowLabel) => {
    const col = classIndex === -1 ? row.total : row.columns[classIndex];
    switch (rowLabel) {
      case '일자':
        return col.date_range ?? '';
      case '출석':
        return col.attendance;
      case '결원':
        return col.absentee;
      case '누적시수':
        return col.cumulative_hours;
      default:
        return '';
    }
  };

  return (
    <div className="page">
      <div className="page-header">
        <h2>수업현황</h2>
        <div className="form-row">
          <div className="form-field form-field-narrow">
            <label>연도</label>
            <select value={year} onChange={(e) => setYear(Number(e.target.value))}>
              {[CURRENT_YEAR - 1, CURRENT_YEAR, CURRENT_YEAR + 1].map((y) => (
                <option key={y} value={y}>{y}</option>
              ))}
            </select>
          </div>
          <div className="form-field form-field-narrow">
            <label>학년</label>
            <select value={grade} onChange={(e) => setGrade(Number(e.target.value))}>
              <option value={1}>1학년</option>
              <option value={2}>2학년</option>
              <option value={3}>3학년</option>
            </select>
          </div>
          <div className="form-field form-field-narrow">
            <label>반구분</label>
            <select value={classtype} onChange={(e) => setClasstype(e.target.value)}>
              <option value="">전체</option>
              <option value="R">정규반</option>
              <option value="M">면장반</option>
            </select>
          </div>
        </div>
      </div>

      <div className="card">
        <h3>{year}학년도 수업현황 ({grade}학년 {CLASSTYPE_LABELS[classtype]}과정)</h3>
        <div className="table-scroll">
          <table className="data-table class-status-table">
            <thead>
              <tr>
                <th>차시</th>
                <th>구분</th>
                {Array.from({ length: classCount }, (_, i) => (
                  <th key={i}>{i + 1}반</th>
                ))}
                <th>계</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                ROW_LABELS.map((label, li) => (
                  <tr key={`${row.unitno}-${label}`}>
                    {li === 0 && (
                      <td rowSpan={ROW_LABELS.length} className="unit-label-cell">
                        {row.unitno}차시
                        <div className="unit-label-sub">{row.subject}</div>
                        <div className="unit-label-sub">{row.chapter}</div>
                      </td>
                    )}
                    <td className="row-label-cell">{label}</td>
                    {Array.from({ length: classCount }, (_, ci) => (
                      <td key={ci}>{cellValue(row, ci, label)}</td>
                    ))}
                    <td className="total-cell">{cellValue(row, -1, label)}</td>
                  </tr>
                ))
              ))}
              {!loading && rows.length === 0 && (
                <tr>
                  <td colSpan={classCount + 3} className="empty-row">데이터가 없습니다.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
